import React from 'react';
import Main from '../layouts/Main';

// Apps and tools with live GitHub Pages deployments
const appsAndTools = [
  {
    title: 'Sigil Generator',
    link: 'https://marcusg999.github.io/sigilgenerator.github.io/',
    image: 'images/projects/sigilGenerator.png',
    desc: 'A browser tool for generating personal sigils.',
  },
  {
    title: 'LBRP Guide',
    link: 'https://marcusg999.github.io/LBRPGuide.github.io/',
    image: 'images/projects/lbrpGuide.png',
    desc: 'An illuminated, interactive guide to the Lesser Banishing Ritual of the Pentagram.',
  },
  {
    title: 'NeuroWave Synth',
    link: 'https://marcusg999.github.io/neurowavesynth.github.io/',
    image: 'images/projects/neurowaveSynth.png',
    desc: 'A browser-based binaural-beats wave synthesizer.',
  },
  {
    title: 'Chakra Balance Quiz',
    link: 'https://marcusg999.github.io/ChakraBalanceQuiz/',
    image: 'images/projects/chakraBalanceQuiz.png',
    desc: 'An interactive quiz that surfaces which chakra is out of balance.',
  },
  {
    title: '777 Ritual Designer',
    link: 'https://marcusg999.github.io/777ritualdesigner/',
    image: 'images/projects/ritualDesigner777.png',
    desc: 'A ritual-design engine that draws symbolic correspondences from Liber 777. Built with TypeScript.',
  },
  {
    title: 'Burroughs Cut-Up Scrambler',
    link: 'https://marcusg999.github.io/BurroughsCutUpScrambler.github.io/',
    image: 'images/projects/burroughsCutUpScrambler.png',
    desc: 'A digital cut-up scrambler that deconstructs and reassembles your text, inspired by William S. Burroughs.',
  },
  {
    title: 'Epinoa',
    link: 'https://marcusg999.github.io/Epinoa/',
    image: 'images/projects/epinoa.png',
    desc: 'An AR tracing assistant for artists. Built with JavaScript.',
  },
];

// Projects with a screenshot but no live deployment
const sourceProjects = [
  {
    title: 'Trading Bot',
    link: 'https://github.com/marcusg999/tradingbot',
    image: 'images/projects/tradingBot.png',
    desc: 'An algorithmic trading bot with a read-only paper-trading dashboard. Built with Python.',
  },
];

const renderProjectList = (items) => items.map((project) => (
  <div key={project.title} style={{ maxWidth: '800px', margin: '0 auto 1.5em' }}>
    {project.image && (
      <a href={project.link} target="_blank" rel="noopener noreferrer">
        <img
          src={project.image}
          alt={project.title}
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
          style={{
            display: 'block',
            maxWidth: '100%',
            margin: '0 auto 0.75em',
            border: '3px solid black',
          }}
        />
      </a>
    )}
    <h3 style={{ marginBottom: '0.2em' }}>
      <a href={project.link} target="_blank" rel="noopener noreferrer">
        {project.title}
      </a>
    </h3>
    <p style={{ margin: 0 }}>{project.desc}</p>
  </div>
));

const AI = () => (
  <Main>
    <div className="ai-page">

      <h2 data-testid="heading">AI</h2>

      <h3>Short AI film Written, directed, edited and prodcued by Marcus Gray</h3>
      <h3> RoadKill Karma</h3>
      <a href="https://www.youtube.com/watch?v=BhWhmSGtZpg">
        <img
          src="images/projects/RoadKill Karma.png"
          alt="AI-related topic"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '800px',
            height: 'auto',
            margin: '0 auto 1.5em',
            border: '3px solid black',
          }}
        />
      </a>
      <h3>YouTube Episode made with AI | For Personal Project</h3>
      <h3> Episode 1:HipHop As a Spirituality</h3>
      <a href="https://youtu.be/SemQvkZLZts?si=gGt77FD71cqgJ2aF">
        <img
          src="/images/projects/hiphopAsaSpirituality.png"
          alt="AI-related topic"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '800px',
            height: 'auto',
            margin: '0 auto 1.5em',
            border: '3px solid black',
          }}
        />
      </a>
      <h3>Short film treated with AI model | For Client</h3>
      <a href="https://youtu.be/u23G1ElnVjM">
        <img
          src="/images/projects/AIeros.png"
          alt="AI-related topic"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '800px',
            height: 'auto',
            margin: '0 auto 1.5em',
            border: '3px solid black',
          }}
        />
      </a>
      <h3>Vesica Academy: Relationship &amp; dating app</h3>
      <a
        href="https://vesicaacademy.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="images/projects/vesicaAcademy.png"
          alt="Vesica Academy"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '800px',
            height: 'auto',
            margin: '0 auto 0.75em',
            border: '3px solid black',
          }}
        />
      </a>
      <h3>
        <a
          href="https://vesicaacademy.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Launch the app
        </a>
      </h3>
      <p style={{ maxWidth: '800px', margin: '0 auto 2em' }}>
        A web-first relationship and dating app that pairs a certification-gated
        learning path with matchmaking. Built and maintained by me.
      </p>

      <header>Apps &amp; Tools</header>
      <p style={{ maxWidth: '800px', margin: '0 auto 1.5em' }}>
        A selection of web apps and utilities I&apos;ve built &mdash; all live below.
      </p>
      {renderProjectList(appsAndTools)}

      <header>More Projects</header>
      {renderProjectList(sourceProjects)}

      <header>AI Art and projects for clients and myself</header>
      <h3>ArtlogixAI: Art client aggregator</h3>
      <h3>AI Agent</h3>
      <a href="https://artlogix-dashboard-production.up.railway.app/">
        <img
          src="images/projects/artlogixAI.png"
          alt="AI-related topic"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '800px',
            height: 'auto',
            margin: '0 auto 1.5em',
            border: '3px solid black',
          }}
        />
      </a>
      {/* Add your AI-related content here */}
    </div>
  </Main>
);

export default AI;
